import { useEffect } from 'react';
import { useUpdateDocumentClass } from 'src/custom-hooks/use-document-class-while-rendered';

export const DESKTOP_ONLY_SCROLL_CLASS = 'desktop-scroll-only';

export const useDocumentDesktopOnlyScroll = () => {
  const updateShouldUseDocumentOnlyScroll = useUpdateDocumentClass(DESKTOP_ONLY_SCROLL_CLASS);

  useEffect(() => {
    updateShouldUseDocumentOnlyScroll(false);

    return () => {
      updateShouldUseDocumentOnlyScroll(false);
    };
  }, [updateShouldUseDocumentOnlyScroll]);

  return updateShouldUseDocumentOnlyScroll;
};
